import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from 'src/app/helpers/string-helper';
import { IP_BOARD_PART_TYPE_CHOICES } from 'src/app/model/product/ip-board/ip-board-part-type';

@Pipe({
  name: 'displayIPBoardType'
})
export class DisplayIPBoardTypePipe implements PipeTransform {
  transform(
    signWidth: number,
    signHeight: number,
    ipBoardPartTypeOrdinal: number,
    otherWidth: number,
    otherHeight: number
  ) {
    const typeLabel =
      signWidth == null &&
      signHeight == null &&
      ipBoardPartTypeOrdinal ===
        IP_BOARD_PART_TYPE_CHOICES.ADHESIVE_BOARD.ordinal
        ? 'Kleefbord'
        : 'IP bord';
    const dimensions =
      ipBoardPartTypeOrdinal === IP_BOARD_PART_TYPE_CHOICES.IP_70_100.ordinal
        ? '70x100'
        : ipBoardPartTypeOrdinal ===
          IP_BOARD_PART_TYPE_CHOICES.IP_100_140.ordinal
        ? '100x140'
        : null;
    if (dimensions != null) {
      return `${typeLabel} ${dimensions}`;
    }
    if (signWidth != null || signHeight != null) {
      return StringHelper.join(
        [
          typeLabel,
          StringHelper.join(
            [
              signWidth == null ? null : '' + signWidth,
              signHeight == null ? null : '' + signHeight
            ],
            'x'
          )
        ],
        ' '
      );
    } else if (otherWidth != null || otherHeight != null) {
      return StringHelper.join(
        [
          typeLabel,
          StringHelper.join(
            [
              otherWidth == null ? null : '' + otherWidth,
              otherHeight == null ? null : '' + otherHeight
            ],
            'x'
          )
        ],
        ' '
      );
    } else {
      return typeLabel;
    }
  }
}
